module.exports = __webpack_public_path__ + "img/completedvisits.6b0f5bdc.png";